<div class="modal-form">
    <h1 mat-dialog-title class="jumbotron-heading ">{{data.title}}</h1>
   
    <mat-dialog-content>
        <lgv-loading-indicator  *ngIf="IsLoading$ | async"></lgv-loading-indicator>
        <mat-radio-group
        aria-labelledby="radio-group-label"
        class="radio-group"
        [(ngModel)]="sendOption">
            <mat-radio-button class="radio-button" *ngFor="let option of options" [value]="option.value">{{option.title}}</mat-radio-button>
        </mat-radio-group>
    </mat-dialog-content>
    <mat-dialog-actions class="dialog-actions row">
        <lgv-loading-indicator *ngIf="IsLoading$ | async"></lgv-loading-indicator>
            <div class="col-12" align="end">
                <button  (click)="OnCancel()" mat-stroked-button >
                    Cancel
                </button>
                <button  mat-stroked-button  style="background-color: #6c757d;border-color: #6c757d; color: #fff;"  
                    (click)="OnSend()">
                    <fa-icon icon="paper-plane" title="Send Client Invitation"></fa-icon>
                    Send
                </button>
            </div>
    </mat-dialog-actions>
    
</div>
